function _waitForElement(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

const SectionContainer = (function () {
  function SectionContainer() {
    _classCallCheck(this, SectionContainer);

    this.constructors = [];
    this.instances = [];

    this._attachListeners();
  }

  _createClass(SectionContainer, [
    {
      key: "_attachListeners",
      value: function _attachListeners() {
        document.addEventListener(
          "shopify:section:load",
          this._onSectionLoad.bind(this)
        );
        document.addEventListener(
          "shopify:section:unload",
          this._onSectionUnload.bind(this)
        );
        document.addEventListener(
          "shopify:section:select",
          this._onSelect.bind(this)
        );
        document.addEventListener(
          "shopify:section:deselect",
          this._onDeselect.bind(this)
        );
        document.addEventListener(
          "shopify:section:reorder",
          this._onReorder.bind(this)
        );
        document.addEventListener(
          "shopify:block:select",
          this._onBlockSelect.bind(this)
        );
        document.addEventListener(
          "shopify:block:deselect",
          this._onBlockDeselect.bind(this)
        );
      },
    },
    {
      key: "register",
      value: function register(type, constructor) {
        var _this = this;

        this.constructors[type] = constructor;
        document
          .querySelectorAll("[data-section-type=".concat(type, "]"))
          .forEach(function (container) {
            _this._createInstance(container, constructor);
          });
      },
      /**
       * Return an object from an array of objects that matches the provided key and value
       */
    },
    {
      key: "_findInstance",
      value: function _findInstance(array, key, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return array[i];
          }
        }
      },
      /**
       * Remove an object from an array of objects by matching the provided key and value
       */
    },
    {
      key: "_removeInstance",
      value: function _removeInstance(array, key, value) {
        var i = array.length;

        while (i--) {
          if (array[i][key] === value) {
            array.splice(i, 1);
            break;
          }
        }

        return array;
      },
    },
    {
      key: "_onSectionLoad",
      value: function _onSectionLoad(event) {
        var container = event.target.querySelector("[data-section-id]");

        if (container) {
          this._createInstance(container);
        }
      },
    },
    {
      key: "_onSectionUnload",
      value: function _onSectionUnload(event) {
        var instance = this._findInstance(
          this.instances,
          "id",
          event.detail.sectionId
        );

        if (!instance) {
          return;
        }

        if (typeof instance.onUnload === "function") {
          instance.onUnload(event);
        }

        this.instances = this._removeInstance(
          this.instances,
          "id",
          event.detail.sectionId
        );
      },
    },
    {
      key: "_onSelect",
      value: function _onSelect(event) {
        var instance = this._findInstance(
          this.instances,
          "id",
          event.detail.sectionId
        );

        if (instance && typeof instance.onSelect === "function") {
          instance.onSelect(event);
        }
      },
    },
    {
      key: "_onDeselect",
      value: function _onDeselect(event) {
        var instance = this._findInstance(
          this.instances,
          "id",
          event.detail.sectionId
        );

        if (instance && typeof instance.onDeselect === "function") {
          instance.onDeselect(event);
        }
      },
    },
    {
      key: "_onReorder",
      value: function _onReorder(event) {
        var instance = this._findInstance(
          this.instances,
          "id",
          event.detail.sectionId
        );

        if (instance && typeof instance.onReorder === "function") {
          instance.onReorder(event);
        }
      },
    },
    {
      key: "_onBlockSelect",
      value: function _onBlockSelect(event) {
        var instance = this._findInstance(
          this.instances,
          "id",
          event.detail.sectionId
        );

        if (instance && typeof instance.onBlockSelect === "function") {
          instance.onBlockSelect(event);
        }
      },
    },
    {
      key: "_onBlockDeselect",
      value: function _onBlockDeselect(event) {
        var instance = this._findInstance(
          this.instances,
          "id",
          event.detail.sectionId
        );

        if (instance && typeof instance.onBlockDeselect === "function") {
          instance.onBlockDeselect(event);
        }
      },
    },
    {
      key: "_createInstance",
      value: function _createInstance(container, constructor) {
        var id = container.getAttribute("data-section-id"),
          type = container.getAttribute("data-section-type");
        constructor = constructor || this.constructors[type];

        if (typeof constructor === "undefined") {
          return;
        }

        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      },
    },
  ]);

  return SectionContainer;
})();

window.sections = new SectionContainer();

(() => {
  /*============================================================================
    Quick Shop
  ==============================================================================*/
  window.QuickShop = function (element) {
    var products = element.querySelectorAll(".homepage-products .product");

    if (!products.length) {
      return;
    }

    element
      .querySelectorAll(".quick-add__modal .quick-add__close")
      .forEach((close) => {
        close.addEventListener("click", closeQuickShop);
      });

    element.querySelectorAll(".quick-add__overlay").forEach((close) => {
      close.addEventListener("click", closeQuickShop);
    });

    var slides = element.querySelectorAll(
      ".product-features__carousel .product-feature"
    );

    products.forEach((product) => {
      product
        .querySelector(".quick-product__btn")
        .addEventListener("click", openQuickShop);
    });

    slides.forEach((product) => {
      product
        .querySelector(".quick-add__button")
        .addEventListener("click", selectVariant);
    });

    function selectVariant(e) {
      var elem = e.currentTarget;
      var color = elem.dataset.color;
      var productId = elem.dataset.productId;
      _selectVariant(productId, color);
    }

    function _selectVariant(productId, color) {
      var form = "#product_form_" + productId;
      _waitForElement(form).then((elem) => {
        elem
          .querySelector('[data-single-option-selector][value="' + color + '"]')
          ?.click();
      });
    }

    function openQuickShop(e) {
      if (window.innerWidth < 769) {
        var elem = e.currentTarget;
        var productId = elem.dataset.productId;
        var btn = document.querySelector(
          '[data-quick-add-holder="' + productId + '"] [data-quick-add-btn]'
        );

        if (btn) {
          var color = btn.dataset.color;
          btn.click();
          _selectVariant(productId, color);
        }
      }
    }

    function closeQuickShop(e) {
      var elem = e.target;
      if (
        elem.classList.contains("quick-add__overlay") ||
        elem.classList.contains("quick-add__close") ||
        elem.closest(".quick-add__close")
      ) {
        document.querySelectorAll(".quick-add__modal").forEach((modal) => {
          modal.classList.remove("is-active");
        });
      }
    }
  };

  /*============================================================================
    Announcement Countdown
  ==============================================================================*/
  (() => {
    document
      .querySelectorAll(".announcement__counter")
      .forEach((announcementCountdown) => {
        const endTime = announcementCountdown.dataset.end;

        if (endTime) {
          const countDownDate = new Date(endTime.replace(" ", "T"));        

          const x = setInterval(function () {
            // Get today's date and time in America/New_York
            const now = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));

            // Find the distance between now and the count down date
            const distance = Math.abs(countDownDate - now);

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours =
              days * 24 +
              Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            announcementCountdown.innerHTML =
              "<span>" +
              (hours < 10 ? "0" + hours : hours) +
              "<span>hrs</span></span> " +
              "<span>" +
              (minutes < 10 ? "0" + minutes : minutes) +
              "<span>min</span></span> " +
              "<span>" +
              (seconds < 10 ? "0" + seconds : seconds) +
              "<span>sec</span></span>";

            if (distance < 0) {
              clearInterval(x);
              //announcementCountdown.innerHTML = 'Currently ongoing!';
            }

            //clearInterval(x);
          }, 1000);
        }
      });
  })();

  /* Initialize toltips at slideshow & articles hotspots */
  if (document.querySelector(".homepage-slideshow [data-tippy-content]")) {
    tippy(".homepage-slideshow [data-tippy-content]", {
      theme: "light",
      interactive: true,
      allowHTML: true,
    });
  }

  /* Arrow buttons actions */
  var arrowButtons = document.querySelectorAll("[data-navigation-arrow]");
  if (arrowButtons.length) {
    arrowButtons.forEach((element) => {
      element.addEventListener("click", function (event) {
        event.preventDefault();
        const currentTarget = event.currentTarget;
        const parentContainer = currentTarget.closest(
          ".slider__custom-navigation"
        );

        if (
          currentTarget.classList.contains("custom-navigation__arrow--left")
        ) {
          parentContainer
            .querySelector(".flickity-prev-next-button.previous")
            .click();
        } else {
          parentContainer
            .querySelector(".flickity-prev-next-button.next")
            .click();
        }
      });
    });
  }

  /*============================================================================
    Footer
  ==============================================================================*/
  var Footer = (function () {
    var element;
    function Footer(elem) {
      element = elem;
      _classCallCheck(this, Footer);

      _init();
    }

    function _init() {
      const windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      if (windowWidth < 768) {
        element
          .querySelectorAll("[data-accordion-toggle]")
          .forEach((accordion) => {
            accordion.addEventListener("click", toggleAccordion);
          });
      } else {
        element
          .querySelectorAll("[data-accordion-toggle]")
          .forEach((accordion) => {
            accordion.removeEventListener("click", toggleAccordion);
            accordion.classList.remove("active");
            let panel = accordion.nextElementSibling;
            panel.style.maxHeight = null;
          });
      }
    }

    function toggleAccordion(event) {
      event.target.classList.toggle("active");
      let panel = event.target.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }

    window.addEventListener("resize", _init);

    _createClass(Footer, [
      {
        key: "onUnload",
        value: function onUnload() {},
      },
    ]);

    return Footer;
  })();

  window.sections.register("footer", Footer);

  /*============================================================================
    Section text row (icon columns)
  ==============================================================================*/
  // var TextRow = (function () {
  //   var carousel;
  //   var element;

  //   function TextRow(elem) {
  //     element = elem;
  //     _classCallCheck(this, TextRow);

  //     _initCarousel();
  //   }

  //   function _initCarousel() {
  //     if (element) {
  //       var mainSlider = element.querySelector(".text-row .wrapper .grid");
  //       const windowWidth =
  //         window.innerWidth ||
  //         document.documentElement.clientWidth ||
  //         document.body.clientWidth;

  //       if (windowWidth < 768) {
  //         carousel = new themeVendor.Flickity(mainSlider, {
  //           pageDots: true,
  //           prevNextButtons: false,
  //           wrapAround: true,
  //           adaptiveHeight: false,

  //           selectedAttraction: 0.05,
  //           friction: 0.8,
  //           contain: false,
  //         });
  //       } else if (carousel) {
  //         carousel.destroy();
  //       }
  //     }
  //   }

  //   _createClass(TextRow, [
  //     {
  //       key: "onUnload",
  //       value: function onUnload() {
  //         carousel.destroy();
  //       },
  //     },
  //   ]);

  //   window.addEventListener("resize", _initCarousel);

  //   return TextRow;
  // })();

  // window.sections.register("text-row", TextRow);

  /*============================================================================
  Section internal navigation
  ==============================================================================*/
  /*
  var InternalNavigation = (function () {
    //var carousel;
    let element;

    function InternalNavigation(elem) {
      element = elem;
      _classCallCheck(this, InternalNavigation);

      _init();
    }

    function _init() {
      let items = element?.querySelectorAll(".internal-navigation__item") || [];

      items.forEach((link) => {
        link.addEventListener("click", function () {
          element
            .querySelectorAll(".internal-navigation__item")
            .forEach((sibling) => {
              sibling.classList.remove("active");
            });
          //this.classList.add('active');
        });
      });
    }

    const sections = document.querySelectorAll(".shopify-section");

    window.addEventListener("scroll", navHighlighter);

    function navHighlighter() {
      let scrollY = window.pageYOffset;

      sections.forEach((current) => {
        let sectionHeight = current.offsetHeight;
        let sectionTop =
          current.getBoundingClientRect().top + window.pageYOffset - 50;
        let sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          let item = element?.querySelector(
            ".internal-navigation__item a[href*=" + sectionId + "]"
          );
          if (item) {
            item.parentNode.classList.add("active");
          }
        } else {
          let item = element?.querySelector(
            ".internal-navigation__item a[href*=" + sectionId + "]"
          );
          if (item) {
            item.parentNode.classList.remove("active");
          }
        }
      });
    }

    _createClass(InternalNavigation, [
      {
        key: "onUnload",
        value: function onUnload() {},
      },
    ]);

    //window.addEventListener('resize', _initCarousel);

    return InternalNavigation;
  })();

  window.sections.register("internal-navigation", InternalNavigation);
  */

  /*============================================================================
    Custom navigation
  ==============================================================================*/
  var CustomNavigation = (function () {
    var container;

    function CustomNavigation(element) {
      container = element;
      _classCallCheck(this, CustomNavigation);

      var statusElements = container.querySelectorAll(
        ".custom-navigation__status"
      );

      if (statusElements) {
        statusElements.forEach((statusElement) => {
          container
            .querySelector("[data-slider]")
            .parentNode.addEventListener("theme:slider:loaded", (event) => {
              const flkty = event.detail.slider.flkty;

              function updateStatus() {
                var slideNumber = flkty.selectedIndex + 1;
                statusElement.innerHTML =
                  "<span>" +
                  slideNumber +
                  "</span>" +
                  "/" +
                  flkty.slides.length;
              }
              updateStatus();

              flkty.on("change", updateStatus);
            });
        });
      } else {
        return;
      }
    }

    _createClass(CustomNavigation, [
      {
        key: "onUnload",
        value: function onUnload() {},
      },
    ]);

    return CustomNavigation;
  })();

  window.sections.register("product-grid", CustomNavigation);
  window.sections.register("shop-the-look", CustomNavigation);
})();

// Scroll arrow on cart
/*
(() => {
  const cartBody = document.querySelector(".cart-dropdown__body");

  if (!cartBody) {
    return;
  }

  const cartFoot = document.querySelector(".cart__foot");

  let lastKnownScrollPosition = 0;
  let ticking = false;

  function doScroll(scrollPos) {
    if (cartFoot.dataset.hasScrollArrow && cartBody.scrollTop > 0) {
      cartFoot.classList.remove("cart__foot--with-scroll-arrow");
    } else if (cartFoot.dataset.hasScrollArrow && cartBody.scrollTop === 0) {
      cartFoot.classList.add("cart__foot--with-scroll-arrow");
    }
  }

  cartBody.addEventListener("scroll", function (e) {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        doScroll(lastKnownScrollPosition);
        ticking = false;
      });

      ticking = true;
    }
  });

  window.addScrollArrowToCart = () => {
    if (!cartFoot) {
      return;
    }

    const hasScroll = cartBody.scrollHeight > cartBody.clientHeight;

    if (hasScroll) {
      cartFoot.classList.add("cart__foot--with-scroll-arrow");
      cartFoot.dataset.hasScrollArrow = "true";
    } else {
      cartFoot.classList.remove("cart__foot--with-scroll-arrow");
      cartFoot.removeAttribute("data-has-scroll-arrow");
    }
  };
})();
*/

/* QUICK ADD SELECTED VARIANT */
(() => {
  document.addEventListener("click", function (e) {
    if (
      e.target.hasAttribute("data-single-option-selector") &&
      e.target.closest(".product-quick-add")
    ) {
      let selected = e.target;
      let value = selected.value;

      // Clear all values
      selected
        .closest(".selector-wrapper")
        .querySelectorAll(".radio__fieldset")
        .forEach((field) => {
          const currentLabel = field.querySelector(
            ".radio__legend__label--current"
          );
          if (currentLabel) {
            currentLabel.innerHTML = "";
          }

          const preorderLabel = field.querySelector(
            ".radio__legend__label--preorder-message"
          );
          if (preorderLabel) {
            preorderLabel.innerHTML = "";
          }
        });

      // Set the actual value in the corresponding fieldset
      selected
        .closest(".radio__fieldset")
        .querySelector(".radio__legend__label--current").innerHTML = value;
    }
  });
})();

/* REWARDS BIRTHDAY SECTION CLICK */
(() => {
  if (document.body.classList.contains("template-page-rewards")) {
    if (sessionStorage.getItem("login-birthday")) {
      if (sessionStorage.getItem("login-birthday") == 1) {
        //Bajar hasta la sección y hacer clear del sessionStorage
        let selector = '[aria-label="BirthdayCampaign"]';

        _waitForElement(selector).then((elem) => {
          let top = elem.offsetTop;
          let header = document.querySelector(".theme__header");
          if (header) {
            top = top - header.clientHeight - 50;
          }

          setTimeout(function () {
            window.scroll({
              top: top,
              behavior: "smooth",
            });
          }, 1000);

          sessionStorage.removeItem("login-birthday");
        });
      }
    }
    document.addEventListener("click", function (e) {
      if (
        e.target.classList.contains("yotpo-sign-in-button") &&
        e.target.closest(".yotpo-logged-out-tile")
      ) {
        sessionStorage.setItem("login-birthday", 1);
      }
    });
  }
})();

(() => {
  /*============================================================================
    Shop the look carousel
  ==============================================================================*/
  var ShopTheLook = (function () {
    function ShopTheLook(element) {
      _classCallCheck(this, ShopTheLook);

      _initCarousel(element);

      _attachListeners(element);

      _initQuickSop(element);
    }

    function _initQuickSop(element) {
      // console.log(element);
      window.QuickShop(element);
    }

    function _initCarousel(element) {
      var mainSlider = element.querySelector(".shop-the-look-carousel");

      if (!mainSlider) {
        return;
      }

      var promises = [];
      element.querySelectorAll(".hotspot-carousel").forEach((elem) => {
        promises.push(
          new Promise(function (resolve, reject) {
            new themeVendor.Flickity(elem, {
              pageDots: true,
              prevNextButtons: false,
              wrapAround: true,
              adaptiveHeight: false,

              selectedAttraction: 0.05,
              friction: 0.8,
              contain: false,
              on: {
                ready: function () {
                  this.activate();
                  resolve();
                },
                change: function (index) {
                  var hotspot = element.querySelector(
                    '.product-features__hotspot[data-product-index="' +
                      index +
                      '"]'
                  );
                  hotspot.parentElement
                    .querySelectorAll(".product-features__hotspot")
                    .forEach((elem) => {
                      elem.classList.remove("is-active");
                    });

                  hotspot.classList.add("is-active");
                },
              },
            });
          })
        );
      });

      Promise.all(promises).then(function AcceptHandler(results) {
        this.flkty = new themeVendor.Flickity(mainSlider, {
          pageDots: false,
          prevNextButtons: true,
          wrapAround: true,
          adaptiveHeight: false,
          draggable: window.innerWidth > 767 ? false : true,
          cellAlign: "left",

          contain: true,

          on: {
            ready: function () {
              setTimeout(() => {
                mainSlider.parentNode.dispatchEvent(
                  new CustomEvent("slider-is-loaded", {
                    bubbles: true,
                    detail: {
                      slider: { flkty: this },
                    },
                  })
                );
              }, 10);
            },
          },
        });

        this.flkty.activate();
      });


      element.querySelectorAll("[data-product-grid-item]").forEach((item) => {
        new window.theme.QuickAddProduct(item);
      });
    }

    function _attachListeners(element) {
      element.querySelectorAll(".product-features__hotspot").forEach((item) => {
        item.addEventListener("click", function (e) {
          if (window.innerWidth > 767) {
            const target = e.target;

            if (
              target.matches(".product-features__hotspot") ||
              target.closest(".product-features__hotspot")
            ) {
              e.preventDefault();

              let slideIdx = 0;
              let selector;
              if (target.matches(".product-features__hotspot")) {
                selector = target;
              } else {
                selector = target.closest(".product-features__hotspot");
              }

              slideIdx = parseInt(selector.getAttribute("data-product-index"));
              const slider = selector
                .closest(".product-features__wrapper")
                .querySelector(".hotspot-carousel");
              const flkty = themeVendor.Flickity.data(slider);

              flkty.select(slideIdx);

              selector.parentElement
                .querySelectorAll(".product-features__hotspot")
                .forEach((elem) => {
                  elem.classList.remove("is-active");
                });

              selector.classList.add("is-active");
            }
          }
        });
      });
    }

    _createClass(ShopTheLook, [
      {
        key: "onUnload",
        value: function onUnload() {},
      },
    ]);

    return ShopTheLook;
  })();

  window.sections.register("shop-the-look", ShopTheLook);
})();
